import Vue from 'vue'; 
import Vuex from 'vuex'; 
import * as types from './types'
Vue.use(Vuex);

const state = {
    token: sessionStorage.getItem('token') || "",
 }

const getters = {
    token: state => state.token,
}

const mutations = {
    [types.SET_TOKEN](state, token) {
        state.token = token
    }
}

const actions = {
    saveToken({ commit }, token) {
        sessionStorage.setItem('token', JSON.stringify(token));
        commit(types.SET_TOKEN, token);
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})


// WEBPACK FOOTER //
// ./src/vuex/store.js